var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SUBSCRIPTION_STATUS } from "../constants/index";
var BasketController = (function () {
    function BasketController() {
        var _this = this;
        var _a, _b, _c, _d;
        this.getBasket = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(this.endpoints.getOrCreate).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.getOrCreateBasket = function () { return __awaiter(_this, void 0, void 0, function () {
            var baskets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getBasket()];
                    case 1:
                        baskets = _a.sent();
                        return [2, baskets];
                }
            });
        }); };
        this.updateLineItem = function (_a) {
            var uuid = _a.uuid, pid = _a.pid, _b = _a.selectedOptionValueID, selectedOptionValueID = _b === void 0 ? '' : _b, _c = _a.customAttr, customAttr = _c === void 0 ? '' : _c, _d = _a.customValue, customValue = _d === void 0 ? '' : _d;
            return __awaiter(_this, void 0, void 0, function () {
                var formData;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            formData = new URLSearchParams();
                            formData.append('uuid', uuid);
                            formData.append('pid', pid);
                            if (selectedOptionValueID)
                                formData.append('selectedOptionValueID', selectedOptionValueID);
                            if (customAttr)
                                formData.append('customAttr', customAttr);
                            if (customValue)
                                formData.append('customValue', customValue);
                            return [4, fetch(this.endpoints.updateLineItem, {
                                    method: 'POST',
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    body: formData.toString()
                                }).then(function (resp) { return resp.json(); })];
                        case 1: return [2, _e.sent()];
                    }
                });
            });
        };
        this.updateItem = function (itemId, body) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(this.endpoints.updateItem + "?uuid=" + itemId + "&pid=" + body.pid + "&quantity=" + body.quantity).then(function (resp) { return resp.json(); })];
                case 1: return [2, _a.sent()];
            }
        }); }); };
        this.removeItems = function (ids) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(this.endpoints.removeItems + "?uuids=" + ids.join('|')).then(function (resp) { return resp.json(); })];
                case 1: return [2, _a.sent()];
            }
        }); }); };
        this.removeItem = function (itemId, productId) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(this.endpoints.removeItem + "?uuid=" + itemId + "&pid=" + productId).then(function (resp) { return resp.json(); })];
                case 1: return [2, _a.sent()];
            }
        }); }); };
        this.addCoupon = function (code, params) { return __awaiter(_this, void 0, void 0, function () {
            var paramString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        paramString = params ? Object.keys(params).map(function (p) { return p + "=" + params[p]; }).join('&') : null;
                        return [4, fetch(this.endpoints.addCoupon + "?couponCode=" + code + "&csrf_token=" + this.csrf + (paramString ? "&" + paramString : ''))
                                .then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.selectShippingMethod = function (shipmentUUID, methodID) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(this.endpoints.selectShippingMethod + "?shipmentUUID=" + shipmentUUID + "&methodID=" + methodID + "&csrf_token=" + this.csrf, {
                            method: 'POST'
                        }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.endpoints = (_b = (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.controllers) === null || _b === void 0 ? void 0 : _b.basket;
        this.csrf = ((_d = (_c = window.reactSystemData) === null || _c === void 0 ? void 0 : _c.csrf) === null || _d === void 0 ? void 0 : _d.token) || '';
    }
    BasketController.prototype.addProducts = function (quantityOrOptions) {
        var products = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            products[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var ogKey, quantity, subscriptionStatus, pidsObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof quantityOrOptions === "number") {
                            quantity = quantityOrOptions;
                        }
                        else {
                            quantity = quantityOrOptions.quantity;
                            subscriptionStatus = quantityOrOptions.subscriptionStatus;
                        }
                        pidsObj = products.map(function (pid) {
                            var _a, _b;
                            var productItem = {};
                            if ((subscriptionStatus === null || subscriptionStatus === void 0 ? void 0 : subscriptionStatus.isEligible) && ((_a = subscriptionStatus === null || subscriptionStatus === void 0 ? void 0 : subscriptionStatus.status) === null || _a === void 0 ? void 0 : _a.subscriptionOptionSelected) && ((_b = subscriptionStatus === null || subscriptionStatus === void 0 ? void 0 : subscriptionStatus.status) === null || _b === void 0 ? void 0 : _b.subscriptionTime)) {
                                ogKey = "og-subscribe-pdp-" + pid;
                                productItem = {
                                    pid: pid,
                                    qty: quantity,
                                    options: "{\"optionId\": \"" + SUBSCRIPTION_STATUS.optionId + "\", \"optionValueId\": \"" + SUBSCRIPTION_STATUS.subscribed + "\"}",
                                    c_subscriptionOptionSelected: subscriptionStatus === null || subscriptionStatus === void 0 ? void 0 : subscriptionStatus.status.subscriptionTime
                                };
                            }
                            else {
                                productItem = {
                                    pid: pid,
                                    qty: quantity
                                };
                            }
                            return productItem;
                        });
                        return [4, fetch("" + this.endpoints.addProducts, {
                                method: "POST",
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: ogKey ? "pidsObj=" + encodeURIComponent(JSON.stringify(pidsObj)) + "&" + encodeURIComponent(ogKey) + "=1" : "pidsObj=" + encodeURIComponent(JSON.stringify(pidsObj))
                            }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.addBonusProducts = function (promoID) {
        var products = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            products[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var pidsObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pidsObj = products.map(function (pid) { return { pid: pid }; });
                        return [4, fetch("" + this.endpoints.addBonusProducts, {
                                method: "POST",
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: "pidsObj=" + encodeURIComponent(JSON.stringify(pidsObj)) + "&promoID=" + encodeURIComponent(promoID)
                            }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.addBonusProduct = function (promoID, productID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch("" + this.endpoints.addBonusProduct, {
                            method: "POST",
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: "pid=" + encodeURIComponent(productID) + "&promoID=" + encodeURIComponent(promoID)
                        }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.removeBonusProduct = function (promoID, productID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch("" + this.endpoints.removeBonusProduct, {
                            method: "POST",
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: "pid=" + encodeURIComponent(productID) + "&promoID=" + encodeURIComponent(promoID)
                        }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.removeCoupon = function (couponId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(this.endpoints.removeCoupon + "?uuid=" + couponId).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.updateProductsInBundle = function (productIds, bundleId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch("" + this.endpoints.updateProductsInBundle, {
                            method: "POST",
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ productIds: productIds, bundleId: bundleId })
                        }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BasketController.prototype.addRemoveBasketBundle = function (productIds, bundleId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch("" + this.endpoints.addRemoveBasketBundle, {
                            method: "POST",
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ productIds: productIds, bundleId: bundleId })
                        }).then(function (resp) { return resp.json(); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    return BasketController;
}());
export { BasketController };
//# sourceMappingURL=basketController.js.map